import { RegionSelect } from '~/pages/region/components/region-select';
import { useUnsavedChangesGuard } from '~/hooks/useUnsavedChangesGuard';
import { baseSchema, schema, Schema } from './district-form.schema';
import { useAuthentication } from '~/hooks/useAuthentication';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { placeholder } from '~/utils/placeholder';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';

interface Props {
  onSubmit: (data: Schema) => void;
  mode: 'create' | 'edit';
  defaultValues?: Schema;
  isLoading: boolean;
}

export function DistrictForm({ defaultValues, mode, isLoading, onSubmit }: Props) {
  const { isSuperUser } = useAuthentication();

  const { formState, register, handleSubmit } = useForm({
    resolver: zodResolver(isSuperUser ? schema : baseSchema),
    defaultValues: defaultValues ?? {},
  });

  const { dialog } = useUnsavedChangesGuard(formState);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="name" label="Namn">
            <Input.Field type="text" {...register('name', { disabled: !isSuperUser })} />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="email" label="E-post">
            <Input.Field type="email" {...register('email')} placeholder={placeholder.email} />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="region" label="Region">
            <RegionSelect
              placeholder="Välj region"
              defaultValue={defaultValues?.region}
              {...register('region', { disabled: !isSuperUser })}
            />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="website" label="Hemsida">
            <Input.Field type="text" {...register('website')} placeholder={placeholder.website} />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Button.Group align="right">
        <Button type="submit" isLoading={isLoading}>
          {{ create: 'Skapa', edit: 'Spara' }[mode]}
        </Button>
      </Button.Group>

      {dialog}
    </form>
  );
}
